module.exports = new __parcel__URL__("nm8_icon.8eea8b8a.png").toString();